export const FIELD_NAMES = {
  ASSERTION_TYPE: 'assertionType',
  ASSERTION_EXPECTED_VALUE: 'assertionExpectedValue',
  CONTINUE_ON_FAILURE: 'continueOnFailure',
  ASSERTION_PROPERTY: 'assertionProperty',
  ASSERTION_JAVASCRIPT: 'assertionJavaScript',
  ASSERTION_VARIABLE_NAME: 'assertionVariableName',
} as const;
